<template>
    <BaseField v-bind="$props" v-on="$listeners">
        <input
            type="text"
            placeholder="Version"
            class="value-field"
            :value="value"
            :maxlength="maxLength"
            @input="$emit('update:value', $event.target.value)"
        />
    </BaseField>
</template>

<script>
import BaseField from '@/pages/monetize/segments/segmentForm/fields/BaseField.vue';

export default {
    name: 'VersionField',
    components: { BaseField },
    props: {
        ...BaseField.props,
        value: String,
        maxLength: {
            type: Number,
            default: 32
        }
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/input.scss";

input[type="text"] {
    width: 100%;
}
</style>
